import { UserSortOption } from '@rematter/frontend-lib-api-client';

import { createQueryHook } from '~/shared/providers/api';
import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';

// New hook-based API for CreatedByFilter
// Uses coreUsersByOrganization for organization-scoped user listing
export const useUsers = createQueryHook(
  'trade.users',
  (params: {
    userIds?: string[];
    searchTerm?: string;
    offset?: number;
    limit?: number;
  }) => ({
    coreUsersByOrganization: {
      __args: {
        filter: {
          ids:
            params.userIds && params.userIds.length > 0
              ? params.userIds
              : undefined,
          searchTerm: params.searchTerm || undefined,
        },
        pagination: {
          offset: params.offset ?? 0,
          limit: params.limit ?? 20,
        },
        sorting: ['FirstNameAsc', 'LastNameAsc'] as UserSortOption[],
      },
      entries: {
        id: true,
        firstName: true,
        lastName: true,
        email: true,
      },
    },
  }),
  {
    select: (data) =>
      data?.coreUsersByOrganization?.entries?.map((entry) => ({
        id: entry.id,
        firstName: entry.firstName,
        lastName: entry.lastName,
        email: entry.email,
      })) ?? [],
  },
);

// Legacy atom-based API for EmailButton (backward compatibility)
export const usersQueryAtom = createQueryAtomFactory(
  'trade.users',
  (params: {
    userId: string;
    searchTerm?: string;
    sorting: UserSortOption[];
    limit?: number;
  }) => ({
    coreUsersByOrganization: {
      __args: {
        filter: {
          ids: [params.userId],
          searchTerm: params.searchTerm,
        },
        pagination: {
          limit: params.limit ?? 10,
          offset: 0,
        },
      },
      entries: {
        id: true,
        firstName: true,
        lastName: true,
        email: true,
      },
    },
  }),
  {
    select: (data) => data?.coreUsersByOrganization?.entries ?? [],
  },
);
